import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TSelectOption } from 'src/app/project/components/input/select/select.model';
import { EPointSearchOperator } from 'src/app/project/modules/points/point-search/point-search.consts';
import { EAdvancedFilterOptions } from '../../../../models/advanced-filter-options.enum';
import {
  TAdvancedFilterSingle,
  TAdvancedFilterTextMandatory,
  TFilterTextOptionsMandatory,
} from '../../../../models/advanced-filter.model';
import { textOperationWithMandatoryOptions } from '../../../../utils/advanced-filter-operator.utils';

@Component({
  selector: 'pp-advanced-filter-account',
  templateUrl: './advanced-filter-account.component.html',
  styleUrl: './advanced-filter-account.component.scss',
  standalone: false,
})
export class AdvancedFilterAccountComponent {
  @Input() ppFilter: TAdvancedFilterSingle;
  @Output() ppFilterChange = new EventEmitter<TAdvancedFilterSingle>();

  value: string;
  option: TFilterTextOptionsMandatory;
  filter: TAdvancedFilterTextMandatory;

  advancedFilterTextOptions = textOperationWithMandatoryOptions;
  EAdvancedFilterOptions = EAdvancedFilterOptions;

  ngOnChanges(): void {
    this.filter = this.ppFilter as TAdvancedFilterTextMandatory;

    this.value = this.filter.value;
    this.option = this.filter.option;
  }

  changeFieldCondition(newCondition: TSelectOption): void {
    this.ppFilter.option = newCondition.value as TFilterTextOptionsMandatory;
    this.option = newCondition.value as TFilterTextOptionsMandatory;

    this.ppFilter.operator = newCondition.operator;

    if (
      newCondition.operator === EPointSearchOperator.IN ||
      newCondition.operator === EPointSearchOperator.NOT_IN
    ) {
      this.ppFilter.value = newCondition.data;
    }

    this.applyChanges();
  }

  applyChanges(): void {
    this.ppFilterChange.emit(this.ppFilter);
  }

  changeFieldValue(value: string): void {
    this.ppFilter.value = value;
    this.applyChanges();
  }
}
